module.exports = __webpack_public_path__ + "static/img/Collect.e0ba6519.png";